export enum TravelProtectionForm {
  TRAVELER_INFO = 'traveler_info',
  TRAVEL_DATES = 'travel_dates',
  RESIDENCE_STATE = 'residence_state',
  FIRST_PAYMENT_DATE = 'first_payment_date',
}
